import * as React from 'react';
import { makeFieldChangeHandle, makeValidateField, randomId } from './util';

export default function TextArea({field, formControls, setFormControls, className=undefined, style=undefined, rows=15, disabled=undefined, maxWordCount=0}){
    let id = randomId();
    console.log("txtareastyle!", style)
    const [validity, setValidity] = React.useState({valid:true, warning:""})
    const [wordCount, setWordCount] = React.useState(0);

    const countWords = ()=>{
	setWordCount((formControls[field.name].value.match(/\S+/g) || []).length);
     }

    
    let handleFieldChange = undefined;
    if(formControls!=undefined){
        const validateField = field.necessary?makeValidateField(field, setValidity, formControls, setFormControls, disabled=false):undefined;
	handleFieldChange = makeFieldChangeHandle(field, setFormControls, validateField);
    }

    React.useEffect(()=>{
	countWords()
    }, [formControls[field.name].value])
		   
   
    return(
        <div className={"input-field label-visible " + (className!=undefined?className:"")} style={style}>
            <label htmlFor={id}>{field.label}</label>
            <textarea rows={rows} disabled={field.disabled} value={formControls!=undefined?formControls[field.name].value:""} onChange={handleFieldChange!=undefined?handleFieldChange:null} id={id} placeholder={field.placeholder!=undefined?field.placeholder:field.label}/>
            {!formControls[field.name].validity.valid?<div className="warning">{formControls[field.name].validity.warning}</div>:<></>}
	    <div><p>Broj riječi u tekstu: {wordCount}</p></div>
        </div>
    )
}
